module.exports = __webpack_public_path__ + "static/img/server3.a6ed098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server3.png
// module id = 17/s
// module chunks = 0